import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {GeneralisationRuleConfiguration} from "./generalisation-rule-configuration";

export enum DataAggregationType {
    Sum = "Summe",
    Mean = "Mittelwert",
    None = "Keine"
}

@JsonObject()
export class GeneralisationConfiguration {

    /**
     * The station parameter names to apply the generalisation
     */
    @JsonProperty()
    declare stationParameterNames: string[];

    /**
     * Aggregationstyp
     */
    @JsonProperty()
    declare aggregationType: DataAggregationType;

    /**
     * The generalisation rules to apply to different periods
     */
    @JsonProperty()
    declare rules: GeneralisationRuleConfiguration[];

    constructor() {}
}